import React, { useState } from 'react'
import { Card, CardContent, IconButton, makeStyles, Typography } from '@material-ui/core'
import indigo from '@material-ui/core/colors/indigo'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'
import classNames from 'classnames'

import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu'

const useStyles = makeStyles((theme: any) => ({
	iconButtonPlay: {
		position: 'absolute',
		opacity: 0,
		right: 11,
		top: 11,
		width: 42,
		height: 42,
		color: 'darkgrey',
		transition: 'color 0.25s, opacity 0.25s',
		'&:hover': {
			color: 'lightgray',
		},
	},
	iconPlay: {
		fontSize: 24,
	},
}))

const initialMenuState = {
	mouseX: null,
	mouseY: null,
}

const DegreeCard = (props: {
	scaleNote: string,
	degree: any,
	isSelected: boolean,
	scale: any,
	onPlayClick: () => void,
	onScaleChange: (scale: any) => void
	onClick: () => void,
}) => {
	const classes = useStyles()

	const {
		degree,
		scaleNote,
		isSelected,
		scale,
		onPlayClick,
		onClick,
		onScaleChange
	} = props

	return (
		<ContextMenuTrigger disable={!scale} id={'degree-card-' + scaleNote}>
			<Card
				className={classNames('scale-card', { empty: degree.empty })}
				style={{
					width: 80 - (isSelected ? 6 * 2 : 0),
					border: isSelected ? '6px solid ' + indigo[300] : undefined,
					height: 80 - (isSelected ? 6 * 2 : 0),
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					margin: 12,
					opacity: degree.empty ? 0.4 : 1,
					transition: 'opacity 0.25s',
					cursor: degree.empty ? undefined : 'pointer'
				}}
				onClick={onClick}
				elevation={isSelected ? 6 : 2}
			>
				<CardContent style={{
					display: 'flex',
					alignContent: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
				}}>
					<Typography variant='h5' component='h2' style={{ marginBottom: 4 }}>
						{degree.name}
					</Typography>
					<Typography variant='body2' component='p'>
						{scaleNote}
					</Typography>
				</CardContent>

				<IconButton onClick={onPlayClick} className={classes.iconButtonPlay} edge='start' color='inherit' aria-label='play audio'>
					<VolumeUpIcon className={classes.iconPlay} />
				</IconButton>

				{scale && (
					<ContextMenu id={'degree-card-' + scaleNote}>
						<MenuItem onClick={(e) => { e.stopPropagation(); onScaleChange(scale) }}>Select<b style={{ marginLeft: 8 }}>{scale.name}</b></MenuItem>
					</ContextMenu>
				)}
				
			</Card>
		</ContextMenuTrigger>
	)
}

export default DegreeCard
